import Vue from 'vue'
import Vuex from 'vuex'
import VueResource from 'vue-resource'
import user from './module/user'
import app from './module/app'
import auth from './module/auth'
import { localRead, session } from '@/libs/util'
// import { baseAjaxParam } from '@/configs/publicFn'

/**
 * @description jsonp请求
 */
Vue.use(VueResource)
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    brandId: null,
    branchId: null,
    cityId: null,
    agentId: null,
    shopId: session.get('shopId') ? Number(session.get('shopId')) : null,
    shopName: null,
    shopNum: null,
    shopAddress: null,
    cityName: null,
    agentName: null,
    brandName: null,
    token: localRead('token'),
    popObj: { // 显示型提示弹窗内容
      show: false,
      tips: '',
      status: 0
    }, // 功能型提示弹窗提示弹窗内容
    loginAt: localRead('loginAt'),
    // 修改时的2天权限--开始时间（往前推多少天）
    startTimeOption: 172800,
    // 修改时的2天权限--结束时间（当前时间）
    endTimeOption: 0,
    // 通用--统一状态
    systemStatus: [],
    // 通用--性别
    systemSex: [],
    // 通用--婚否
    systemMarry: [],
    // 通用--血型
    systemBloodType: [],
    // 通用--进店渠道
    systemStoreChannel: [],
    // 通用--支付单据类型
    systemBillType: [],
    // 通用--支付单据类型
    systemPayment: [],
    // 通用--短信验证码
    systemSmsType: [],
    // 通用--营业所属部门
    systemBusiness: [
      {
        value: '12211',
        label: '美容部'
      },
      {
        value: '12212',
        label: '美发部'
      },
      {
        value: '12213',
        label: '美甲部'
      }
    ],
    // 通用--业绩归属部门
    systemAchievement: [],
    // 现场管理--是否是会员
    systemIsCard: [],
    // 现场管理--单据支付类型
    systemRechargeType: [],
    // 现场管理--新老顾客
    systemCustomerNewOld: [],
    // 现场管理--领取方式
    systemReceiveTypeList: [
      { code: 90060, comment: '带走' },
      { code: 90061, comment: '留店' }
    ],
    // 折扣类别
    systemRebateTypeList: [
      {
        value: '1',
        label: '基础类'
      },
      {
        value: '2',
        label: '洗剪类'
      },
      {
        value: '3',
        label: '烫发类'
      },
      {
        value: '4',
        label: '染发类'
      },
      {
        value: '5',
        label: '护理类'
      },
      {
        value: '6',
        label: '美容基础类'
      }
    ],
    // 统计分类
    systemCountTypeList: [
      {
        value: '1',
        label: '基础类'
      },
      {
        value: '2',
        label: '特价类'
      },
      {
        value: '3',
        label: '养生类'
      },
      {
        value: '4',
        label: '彩妆类'
      },
      {
        value: '5',
        label: '团购类'
      },
      {
        value: '6',
        label: '补贴类'
      },
      {
        value: '7',
        label: '团购类'
      }
    ],
    // 会员中心--会员卡状态
    systemVipCardStatus: [],
    // 员工管理--本店人员
    systemShopPerson: [],
    // 基础设置--门店信息
    systemShopList: [],
    // 会员中心--帐户类型
    systemAccountType: [],
    // 基础设置-供应厂家
    systemSupplier: [],
    // 基础设置-品牌名称
    systemProductBranch: [],
    // 基础设置-标准单位
    systemStandArdunit: [],
    // 卡类别
    systemCardClass: [],
    // 有效期类型
    systemExpiryDateType: [],
    // 收款方
    systemPayeeType: [],
    // 外部合作厂家
    systemWorkVender: [],
    /* 支付归类 */
    systemPaymenntClass: [],
    // 后台获取的用户权限
    userauthlist: [],
    // 部门类型
    systemDeparTment: [],
    // 部门类型
    systemDepartment: [],
    // 会员异动信息
    systemUpactiontype: [],
    /* 账户状态 */
    systemAcountStatus: [],
    /* 终端信息 */
    systemPlatformtype: []
  },
  mutations: {
    // 提示弹窗
    popSet (state, obj) {
      state.popObj.tips = obj.tips
      state.popObj.status = obj.status
      state.popObj.show = true
      setTimeout(() => {
        state.popObj.show = false
      }, obj.time)
    },
    setLoginAt (state, data) {
      state.loginAt = data
    },
    setShopId (state, data) {
      state.shopId = data
    },
    setBrandId (state, data) {
      // console.log('品牌id：', data)
      state.brandId = data
      state.branchId = data
    },
    setShopName (state, data) {
      // console.log('品牌id：', data)
      state.shopName = data
    },
    setShopNum (state, data) {
      // console.log('品牌id：', data)
      state.shopNum = data
    },
    setBrandName (state, data) {
      // console.log('品牌id：', data)
      state.brandName = data
    },
    setCityName (state, data) {
      // console.log('品牌id：', data)
      state.cityName = data
    },
    setAgentName (state, data) {
      // console.log('品牌id：', data)
      state.agentName = data
    },
    setCityId (state, data) {
      // console.log('地区id：', data)
      state.cityId = data
    },
    setAgentId (state, data) {
      // console.log('区域id：', data)
      state.agentId = data
    },
    setSystemStatus (state, data) {
      // console.log('通用--统一状态：', data)
      state.systemStatus = data
    },
    setSystemSex (state, data) {
      // console.log('通用--性别：', data)
      state.systemSex = data
    },
    setSystemMarry (state, data) {
      // console.log('通用--婚否：', data)
      state.systemMarry = data
    },
    setSystemBloodType (state, data) {
      // console.log('通用--血型：', data)
      state.systemBloodType = data
    },
    setSystemStoreChannel (state, data) {
      // console.log('通用--进店渠道：', data)
      state.systemStoreChannel = data
    },
    setSystemBillType (state, data) {
      // console.log('通用--支付单据类型：', data)
      state.systemBillType = data
    },
    setSystemPayment (state, data) {
      // console.log('通用--支付方式：', data)
      state.systemPayment = data
    },
    setSystemSmsType (state, data) {
      // console.log('通用--短信验证码：', data)
      state.systemSmsType = data
    },
    setSystemBusiness (state, data) {
      // console.log('通用--营业所属部门：', data)
      state.systemBusiness = data
    },
    // setSystemAchievement (state, data) {
    //   // console.log('通用--业绩归属部门：', data)
    //   state.systemAchievement = data
    // },
    setSystemIsCard (state, data) {
      // console.log('现场管理--是否是会员：', data)
      state.systemIsCard = data
    },
    setSystemRechargeType (state, data) {
      // console.log('现场管理--单据支付类型：', data)
      state.systemRechargeType = data
    },
    setSystemCustomerNewOld (state, data) {
      // console.log('现场管理--新老顾客：', data)
      state.systemCustomerNewOld = data
    },
    setSystemReceiveTypeList (state, data) {
      // console.log('现场管理--产品领取方式：', data)
      state.systemReceiveTypeList = data
    },
    setShopPerson (state, data) {
      // console.log('销售人员：', data)
      state.systemShopPerson = data
    },
    setShopList (state, data) {
      // console.log('门店信息：', data)
      state.systemShopList = data
    },
    setAccountType (state, data) {
      // console.log('帐户类型：', data)
      state.systemAccountType = data
    },
    setSystemVipCardStatus (state, data) {
      // console.log('会员中心--会员卡状态：', data)
      state.systemVipCardStatus = data
    },
    setSystemSupplier (state, data) {
      // console.log('供应厂家：', data)
      state.systemSupplier = data
    },
    setSystemProductBranch (state, data) {
      // console.log('品牌名称', data)
      state.systemProductBranch = data
    },
    setSystemStandArdunit (state, data) {
      // console.log('标准单位', data)
      state.systemStandArdunit = data
    },
    setSystemCardClass (state, data) {
      // console.log('卡类别', data)
      state.systemCardClass = data
    },
    setSystemExpiryDateType (state, data) {
      // console.log('有效期类型', data)
      state.systemExpiryDateType = data
    },
    setSystemPayeeType (state, data) {
      // console.log('收款方', data)
      state.systemPayeeType = data
    },
    setSystemWorkVender (state, data) {
      // console.log('外部合作厂家', data)
      state.systemWorkVender = data
    },
    setSystemWorkPaymenntClass (state, data) {
      // console.log('外部合作厂家', data)
      state.systemPaymenntClass = data
    },
    /* 保存用户权限 */
    setuserauthlist (state, data) {
      state.userauthlist = data
    },
    // 部门类型
    setSystemDeparTment (state, data) {
      state.systemDeparTment = data
      state.systemDepartment = data
      state.systemAchievement = data
    },
    setSystemUpactiontype (state, data) {
      state.systemUpactiontype = data
    },
    setSystemAcountStatus (state, data) {
      state.systemAcountStatus = data
    },
    setSystemPlatformtype (state, data) {
      state.systemPlatformtype = data
    }
  },
  actions: {},
  modules: {
    user,
    app,
    auth
  }
})
